import React from 'react';
import { clsx } from 'clsx';
import {
  getIconByExtension,
  UploadingFileIcon,
} from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseIcons/CurrentKnowledgeBaseIcons';
import { EditFilePopup } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/EditFilePopup/EditFilePopup';
import { DeleteKnowledgeBaseItemModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/delete/DeleteKnowledgeBaseItemModal/DeleteKnowledgeBaseItemModal';
import { useLoader } from 'src/provider/LoaderProvider';
import { useDeleteKnowledgeBaseFilesMutation } from 'src/services';
import { FILE_STATE } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/CurrentKnowledgeBaseConstants';

export const AddFAQItem = ({ item, knowledgeBase }) => {
  const loader = useLoader();
  const is = {
    uploading: item.state === FILE_STATE.UPLOADING,
    deleting: item.state === FILE_STATE.DELETING,
    error: [FILE_STATE.UPLOAD_ERROR, FILE_STATE.DELETE_ERROR].includes(item.state),
  };
  const name = item?.name?.replace(/\.[^/.]+$/, '') || '';
  const [deleteKnowledgeBaseFiles] = useDeleteKnowledgeBaseFilesMutation();

  const onDelete = async (item) => {
    if (item) {
      loader.show();
      await deleteKnowledgeBaseFiles({
        id: knowledgeBase.id,
        body: [item.id],
      });
      loader.hide();
    }
  };

  return (
    <div
      className={clsx(
        '-mx-5 pr-5 py-4 bg-[#F1F6F6] flex flex-row px-5 items-center justify-between gap-4',
        (is.uploading || is.deleting) && 'opacity-50 pointer-events-none',
        is.error && 'opacity-50 bg-gray-200',
      )}
    >
      <div>
        {is.uploading || is.deleting ? <UploadingFileIcon /> : getIconByExtension(item.name)}
      </div>
      <div
        className={
          'block w-full max-w-[84%] min-w-0 overflow-hidden whitespace-nowrap text-ellipsis font-medium'
        }
      >
        {name && <p>{name}</p>}
      </div>
      <div className={'flex flex-row gap-7'}>
        <div className={'flex items-center opacity-50 hover:opacity-100 cursor-pointer'}>
          {!is.error && <EditFilePopup item={{ ...item }} knowledgeBase={knowledgeBase} />}
        </div>
        <div className={'flex items-center'}>
          <DeleteKnowledgeBaseItemModal
            handleSingleItemDelete={onDelete}
            item={{ ...item, data: item }}
          />
        </div>
      </div>
    </div>
  );
};
